import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import { apiDefaultFetcher, apiDeleteFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  CreateSiteOperatorResponse,
  CreateSiteOperatorVars,
  DeleteSiteOperatorResponse,
  DeleteSiteOperatorVars,
  ListSiteOperatorsResponse,
  ListSiteOperatorsVars,
  SiteOperatorApiPath,
  UpdateSiteOperatorResponse,
  UpdateSiteOperatorVars
} from '@/common/api/params/siteOperator'

export const useSiteOperatorListApi = (vars: ListSiteOperatorsVars) => {
  return useSWR<ListSiteOperatorsResponse, Response, [string, ListSiteOperatorsVars]>(
    [SiteOperatorApiPath.LIST_SITE_OPERATORS, vars],
    apiDefaultFetcher
  )
}

export const useSiteOperatorGetApi = ({
  site_id,
  operator_id
}: {
  site_id: number
  operator_id: number
}) => {
  const response = useSiteOperatorListApi({ site_id })
  return {
    ...response,
    data: response.data ? response.data.find((op) => op.id === operator_id) : undefined
  }
}

export const fetchSiteOperatorGetApiByEmail = async (siteId: number, email: string) => {
  const response = await apiDefaultFetcher<ListSiteOperatorsResponse>([
    SiteOperatorApiPath.LIST_SITE_OPERATORS,
    { site_id: siteId, email }
  ])
  return response.find((op) => op.email === email)
}

export const useSiteOperatorCreateApi = (options?: MutationOptions<CreateSiteOperatorResponse>) => {
  return useCallMutation<CreateSiteOperatorResponse, CreateSiteOperatorVars>(
    SiteOperatorApiPath.CREATE_SITE_OPERATOR,
    options
  )
}

export const useSiteOperatorUpdateApi = (options?: MutationOptions<UpdateSiteOperatorResponse>) => {
  return useCallMutation<UpdateSiteOperatorResponse, UpdateSiteOperatorVars>(
    SiteOperatorApiPath.UPDATE_SITE_OPERATOR,
    options,
    apiPutFetcher
  )
}

export const useSiteOperatorDeleteApi = (options?: MutationOptions<DeleteSiteOperatorResponse>) => {
  return useCallMutation<DeleteSiteOperatorResponse, DeleteSiteOperatorVars>(
    SiteOperatorApiPath.DELETE_SITE_OPERATOR,
    options,
    apiDeleteFetcher
  )
}
